import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaUserCircle,
  FaExclamationTriangle,
  FaHome,
  FaCreditCard,
  FaBuilding,
  FaTools,
  FaShieldAlt,
  FaHeadset,
  FaBolt,
  FaChartLine,
} from "react-icons/fa";
import SocialWidget from "../components/floatingwidget";

const Customercare = () => {
  return (
    <div className="w-full min-h-screen bg-white font-sans">
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight  uppercase tracking-tight">
                Customer <span className="text-yellow-400">Care</span>
              </h2>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
              <p className="text-sm sm:text-base md:text-lg opacity-90 max-w-3xl font-normal">
                Your comfort and satisfaction are our priority. We're here to serve you 24/7 with reliable support.
              </p>
            </div>
            <div className="mt-8 lg:mt-0 lg:w-1/3 flex justify-center">
              <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-white/10">
                <FaHeadset className="text-4xl text-white shadow-xl" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* QUICK CONTACT BANNER */}
      <div className="bg-yellow-400 text-black py-8 shadow-xl relative z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="flex flex-col items-center group">
              <div className="w-10 h-10 bg-black text-yellow-400 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <FaPhoneAlt className="text-base" />
              </div>
              <span className="text-lg md:text-xl font-bold tracking-tight">0700 000 2332</span>
              <span className="text-[10px] font-bold uppercase opacity-75 mt-1 tracking-widest">Call Center (24/7)</span>
            </div>
            <div className="flex flex-col items-center group">
              <div className="w-10 h-10 bg-[#14532d] text-white rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform font-bold">
                <FaWhatsapp className="text-base" />
              </div>
              <span className="text-lg md:text-xl font-bold tracking-tight">08125277248</span>
              <span className="text-[10px] font-bold uppercase opacity-75 mt-1 tracking-widest">WhatsApp Support</span>
            </div>
            <div className="flex flex-col items-center group text-center">
              <div className="w-10 h-10 bg-black text-yellow-400 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <FaEnvelope className="text-base" />
              </div>
              <div className="flex flex-col">
                <span className="text-xs sm:text-sm font-bold break-all">customercomplaints@beninelectric.com</span>
                <span className="text-xs sm:text-sm font-bold break-all">servicedesk@beninelectric.com</span>
              </div>
              <span className="text-[10px] font-bold uppercase opacity-75 mt-1 tracking-widest">Email Support</span>
            </div>
          </div>
        </div>
      </div>

      {/* CENTERED IMAGE SECTION */}
      <section className="w-full bg-white py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-4 md:border-8 border-white ring-1 ring-gray-100">
            <img
              src="/images/service-band-banner.jpg"
              alt="BEDC Service Banner"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="w-full bg-white px-4 sm:px-8 lg:px-16 pb-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-12">

          {/* LEFT SIDEBAR */}
          <div className="space-y-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-1 bg-yellow-400 rounded-full"></div>
                <h2 className="text-xs font-bold text-green-700 uppercase tracking-widest">
                  Welcome
                </h2>
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-black mb-6 uppercase leading-tight">
                Quality Service, <span className="text-green-700 block">Every Time.</span>
              </h2>

              <p className="text-gray-600 text-sm leading-relaxed mb-6 font-normal">
                Serving our list of esteemed long-term clients, we are an
                organization of seasoned professionals with a tremendous breadth
                of electrical and managerial experience and expertise across
                multiple industries.
              </p>

              <div className="bg-black text-white p-6 rounded-2xl shadow-xl border-l-8 border-green-700">
                <h3 className="font-bold text-lg uppercase mb-4 tracking-tight">Service Hours</h3>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-green-700 p-1 rounded-full"><FaClock size={10} /></div>
                    <div>
                      <p className="text-[9px] font-bold uppercase text-gray-400 tracking-widest">Call Center</p>
                      <p className="font-semibold">Available 24/7</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-green-700 p-1 rounded-full"><FaClock size={10} /></div>
                    <div>
                      <p className="text-[9px] font-bold uppercase text-gray-400 tracking-widest">Physical Offices</p>
                      <p className="font-semibold">Mon – Fri: 8am – 5pm</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-green-700 p-1 rounded-full"><FaMapMarkerAlt size={10} /></div>
                    <div>
                      <p className="text-[9px] font-bold uppercase text-gray-400 tracking-widest">Head Office</p>
                      <p className="font-semibold">No 5 Akpakpava Road, Benin City</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm">
              <h3 className="font-bold text-black uppercase mb-4 tracking-tight text-sm">Support Channels</h3>
              <ul className="space-y-3">
                {[{title:"Complaints Portal", link:"https://crm.beninelectric.com/complaints"}, {title: 'Meter Installation Guide', link:"https://imaap.beninelectric.com:55682/"},
                  {title: 'Safety Guidelines', link:"/personal-protective-equipment-ppe-policy"},{title:'Online Bill Payment', link:"/e-payment-channels"}].map((item, idx) => (
                    <li key={idx}>
                      <a href={item.link} className="flex items-center justify-between p-3 bg-white border border-gray-100 rounded-xl hover:border-green-700 hover:shadow-md transition-all group">
                        <div className="flex items-center gap-3">
                          <FaBolt className="text-green-700 group-hover:text-yellow-500 transition-colors text-sm" />
                          <span className="font-semibold text-xs text-gray-700 group-hover:text-black transition-colors">{item.title}</span>
                        </div>
                        <span className="text-gray-300 group-hover:text-green-700 transition-colors text-xs">→</span>
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          {/* MAIN CONTENT GRID */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <ServiceCard
                icon={<FaExclamationTriangle className="text-2xl text-green-700" />}
                title="PPM Token Resolution"
                description="If unable to load meter or get your recharge token, kindly click here for immediate assistance."
                action="Report Token Issue"
                bgColor="bg-white"
                borderColor="border-green-100"
                hoverBorder="hover:border-green-700"
                link= "https://crm.beninelectric.com/complaints"
              />

              <ServiceCard
                icon={<FaHome className="text-2xl text-yellow-600" />}
                title="Moving Home"
                description="Inform us at least 48 hours prior to relocation when you change address."
                action="Update Address"
                bgColor="bg-white"
                borderColor="border-yellow-100"
                hoverBorder="hover:border-yellow-400"
                link= "/contact"
              />

              <ServiceCard
                icon={<FaChartLine className="text-2xl text-green-700" />}
                title="Tariffs and Rates"
                description="NERC approved tariffs tailored to meet energy demands across different levels."
                action="View Tariff Rates"
                bgColor="bg-white"
                borderColor="border-green-100"
                hoverBorder="hover:border-green-700"
                link= "/tariff"
              />

              <ServiceCard
                icon={<FaBuilding className="text-2xl text-black" />}
                title="New Properties"
                description="Connect your entirely new home or outer building to our electricity supply."
                action="Request Connection"
                bgColor="bg-white"
                borderColor="border-gray-100"
                hoverBorder="hover:border-black"
                link= "https://newsetup.beninelectric"
              />

              <ServiceCard
                icon={<FaCreditCard className="text-2xl text-yellow-600" />}
                title="Bills and Payments"
                description="Pay your bills anywhere via Bank, POS, Online or our Physical Offices."
                action="Pay Your Bill"
                bgColor="bg-white"
                borderColor="border-yellow-100"
                hoverBorder="hover:border-yellow-400"
                link= "/e-payment-channels"
              />

              <ServiceCard
                icon={<FaUserCircle className="text-2xl text-green-700" />}
                title="Extra Care Service"
                description="Special assistance for relatives with disability or genuine hardship."
                action="Apply for Extra Care"
                bgColor="bg-white"
                borderColor="border-green-100"
                hoverBorder="hover:border-green-700"
                link= "https://crm.beninelectric.com/"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ADDITIONAL SERVICES */}
      <section className="bg-gray-50 py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-4 uppercase tracking-tight">
              Additional <span className="text-green-700">Services</span>
            </h3>
            <div className="w-20 h-1.5 bg-yellow-400 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Safety Complaints */}
            <div className="group text-center p-8 bg-white rounded-2xl border border-transparent shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="inline-block p-4 bg-yellow-400 text-black rounded-2xl mb-6 group-hover:bg-black group-hover:text-yellow-400 transition-colors">
                <FaShieldAlt className="text-3xl" />
              </div>
              <h4 className="font-bold text-xl text-black mb-3 uppercase tracking-tight">Safety Issues</h4>
              <p className="text-gray-600 text-sm leading-relaxed font-normal">
                Report electrical hazards and safety concerns immediately to protect your community.
              </p>
            </div>

            {/* Fault Reporting */}
            <div className="group text-center p-8 bg-white rounded-2xl border border-transparent shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="inline-block p-4 bg-green-700 text-white rounded-2xl mb-6 group-hover:bg-black transition-colors">
                <FaTools className="text-3xl" />
              </div>
              <h4 className="font-bold text-xl text-black mb-3 uppercase tracking-tight">Reporting Faults</h4>
              <p className="text-gray-600 text-sm leading-relaxed font-normal">
                Report power outages and electrical faults in your area for rapid response teams.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="bg-black text-white py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 text-center">
          <div className="inline-block p-3 bg-[#14532d] rounded-full mb-6">
            <FaPhoneAlt className="text-2xl text-white" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 uppercase tracking-tight">
            Need Immediate <span className="text-yellow-400">Assistance?</span>
          </h2>
          <p className="text-sm sm:text-base opacity-90 mb-8 max-w-2xl mx-auto font-normal leading-relaxed">
            Our customer care team is available 24/7 to address your concerns and provide solutions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:07000002332"
              className="bg-yellow-400 text-black font-bold px-8 py-4 rounded-xl hover:bg-white transition-all flex items-center justify-center gap-2 uppercase tracking-wider text-xs shadow-lg"
            >
              Call Now: 0700 000 2332
            </a>
            <a
              href="/contact"
              className="bg-transparent border-2 border-white text-white font-bold px-8 py-4 rounded-xl hover:bg-white hover:text-black transition-all flex items-center justify-center gap-2 uppercase tracking-wider text-xs shadow-lg"
            >
              Send Message
            </a>
          </div>
        </div>
      </section>
      <SocialWidget/>

    </div>
  );
};

export default Customercare;

/* ENHANCED CARD COMPONENT */
function ServiceCard({ icon, title, description, action, bgColor, borderColor, hoverBorder,link }) {
  return (
    <div className={`${bgColor} ${borderColor} ${hoverBorder} rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-xl transition-all duration-300 border group hover:-translate-y-1 relative overflow-hidden flex flex-col justify-between`}>
      <div>
        <div className="mb-6">
          <div className="inline-block p-3 bg-gray-50 rounded-xl border border-gray-100 group-hover:bg-white transition-colors">
            {icon}
          </div>
        </div>
        <h3 className="text-lg font-bold text-black mb-3 uppercase tracking-tight">{title}</h3>
        <p className="text-gray-600 text-sm mb-6 leading-relaxed font-normal">{description}</p>
      </div>
      <a
        href={link}
        className="inline-flex items-center gap-2 font-bold text-green-700 uppercase text-xs tracking-wider group/link"
      >
        {action}
        <span className="transform group-hover/link:translate-x-1 transition-transform">→</span>
      </a>
    </div>
  );
}